export default {
  title: 'Sales team report',
  fields: {
    name: 'Name',
    area: 'Area',
    signed: 'Signed',
    live: 'Live',
  },
  buttons: {
    download_report: 'Download report',
  },
  toasts: {
    failed_to_load_data: 'Failed to load data, please refresh the page',
  },
};
